
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FD6481","d":"M2 5H0v14a2 2 0 002 2h14v-2H2V5z"}}),_c('rect',{attrs:{"width":"15","height":"15","x":"5","y":"1","stroke":"#FD6481","stroke-width":"2","rx":"1"}}),_c('path',{attrs:{"fill":"#FD6481","d":"M16 8.5l-5.25 3.031V5.47L16 8.5z"}})])
          )
        }
      }
    